<script setup>
import {computed, ref, watch} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import {useComponentsStore} from '@/stores/components'
import {useItemDataStore} from '@/stores/itemData'
import {useViewStore} from '@/stores/view'

// Define Props
const props = defineProps({
    viewId: String,
})

// Dynamic View Store
const viewStore = useViewStore(props.viewId)

// Router Composables
const route = useRoute()
const router = useRouter()

// Pinia Stores
const componentsStore = useComponentsStore()
const itemDataStore = useItemDataStore()

// Local Reactive State replacing useAsyncState
const productTitle = ref('')

// Computed Properties
const tableName = computed(() => viewStore.tableName)

const component = computed(() => {
    return componentsStore.items.find(o => o.tableName === tableName.value) || {}
})

const show = computed(() => {
    return tableName.value !== 'account_settings'
})

const productId = computed(() => {
    return parseInt(route.query.productId)
})

// Native fetch logic replacing useAsyncState
watch(
    () => [tableName.value, productId.value],
    async ([newTable, newProductId]) => {
        if (
            newTable &&
            newTable.indexOf('product_variations__') === 0 &&
            newProductId
        ) {
            const obj = await itemDataStore.get({
                tableName: 'm_products_products',
                id: newProductId
            })
            productTitle.value = obj ? obj.title : ''
        } else {
            productTitle.value = ''
        }
    },
    {immediate: true}
)

// Methods
const goToProductListing = () => {
    router.push({
        name: 'list',
        params: {
            component: 'm_products_products'
        }
    })
}

const goToProduct = () => {
    router.push({
        name: 'form',
        params: {
            component: 'm_products_products',
            id: productId.value
        }
    })
}
</script>

<template>
    <span v-if="show" class="ms-1 d-none d-md-inline-flex align-items-center small">
        <template v-if="productTitle">
            <small role="button" class="px-2" @click="goToProductListing">Products</small>
            <i class="bi-chevron-compact-right"/>
            <small role="button" class="px-2" @click="goToProduct">{{ productTitle }}</small>
            <i class="bi-chevron-compact-right"/>
            <small class="px-2">Variations</small>
        </template>
        <small v-else class="px-2">{{ component.title }}</small>
    </span>
</template>